import { render } from "./tempshow.vue?vue&type=template&id=02f19c8d"
import script from "./tempshow.vue?vue&type=script&lang=js"
export * from "./tempshow.vue?vue&type=script&lang=js"

import "./tempshow.vue?vue&type=style&index=0&id=02f19c8d&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__